import noop from "../../../util/noop";
import { buttonVariants } from "./buttonVariants";
import "./buttonDefault.css";

type Props = {
  children?: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: keyof typeof buttonVariants;
  title?: string;
};

export function ButtonDefault({
  children,
  className = "",
  onClick = noop,
  variant = buttonVariants.ghost,
  title = "",
}: Props) {
  const accessibleProps = title
    ? {
        title,
        "aria-label": title,
      }
    : {};
  return (
    <button
      className={`button-default button-${variant} ${className}`}
      onClick={onClick}
      role="button"
      {...accessibleProps}
    >
      {children}
    </button>
  );
}
